/* ============================================================
   Accessibility: keyboard support for desktop dropdown menus
   WCAG 2.1.1 (Keyboard), 1.4.13 (Content on Hover or Focus),
   4.1.2 (Name, Role, Value)

   Your header uses the theme's "normal" dropdowns (the + menus),
   which open with CSS on hover. assets/custom.css now also opens
   them on keyboard focus (:focus-within). This file adds:
   - Escape to close an open dropdown
   - aria-expanded so screen readers hear open/closed

   It also supports the theme's JS mega menus, in case any are
   added later.

   Mouse hover behaviour is not changed.
   To remove: delete the a11y-menu.js line in layout/theme.liquid.
   ============================================================ */
(function () {
  'use strict';

  function isKeyboardFocus(el) {
    try {
      return el.matches(':focus-visible');
    } catch (e) {
      return document.body.classList.contains('focus-outline');
    }
  }

  /* ---------- CSS hover dropdowns (the + menus) ---------- */
  function initCssDropdowns() {
    var items = document.querySelectorAll('.site-nav__item-1');

    Array.prototype.forEach.call(items, function (item) {
      var link = item.querySelector(':scope > a');
      var panel = item.querySelector('.site-nav__dropdown-1');
      if (!link || !panel) return;

      link.setAttribute('aria-haspopup', 'true');
      link.setAttribute('aria-expanded', 'false');

      item.addEventListener('focusin', function () {
        item.classList.remove('a11y-dismissed');
        link.setAttribute('aria-expanded', 'true');
      });

      item.addEventListener('focusout', function (event) {
        if (!item.contains(event.relatedTarget)) {
          item.classList.remove('a11y-dismissed');
          link.setAttribute('aria-expanded', 'false');
        }
      });

      /* Hovering always works normally, even after Escape */
      item.addEventListener('mouseenter', function () {
        item.classList.remove('a11y-dismissed');
      });

      item.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' || event.key === 'Esc') {
          event.preventDefault();
          /* Move focus first: focusing the link fires focusin,
             which would otherwise undo the dismissed state */
          link.focus();
          item.classList.add('a11y-dismissed');
          link.setAttribute('aria-expanded', 'false');
        }
      });

      /* Re-open with Down arrow after Escape */
      link.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowDown' && item.classList.contains('a11y-dismissed')) {
          event.preventDefault();
          item.classList.remove('a11y-dismissed');
          link.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  /* ---------- Theme JS mega menus (.has-dropdown) ---------- */
  function initMegaMenus() {
    var navs = document.querySelectorAll('ap-navigationofdesktop');

    Array.prototype.forEach.call(navs, function (nav) {
      if (typeof nav.openDropdown !== 'function' || typeof nav.closeDropdown !== 'function') {
        return;
      }

      var items = nav.querySelectorAll('.has-dropdown');

      Array.prototype.forEach.call(items, function (item) {
        var link = item.querySelector('[ap-controlsaria]');
        if (!link) return;

        var panelId = link.getAttribute('ap-controlsaria');
        var panel = document.getElementById(panelId);
        if (!panel) return;

        link.setAttribute('aria-haspopup', 'true');
        link.setAttribute('aria-controls', panelId);
        link.setAttribute('aria-expanded', link.getAttribute('ap-expanded-aria') === 'true' ? 'true' : 'false');

        new MutationObserver(function () {
          link.setAttribute('aria-expanded', link.getAttribute('ap-expanded-aria') === 'true' ? 'true' : 'false');
        }).observe(link, { attributes: true, attributeFilter: ['ap-expanded-aria'] });

        function isOpen() {
          return link.getAttribute('ap-expanded-aria') === 'true';
        }

        function close() {
          if (isOpen()) nav.closeDropdown(item);
        }

        link.addEventListener('focus', function () {
          if (isKeyboardFocus(link) && !isOpen()) {
            nav.openDropdown(item);
          }
        });

        item.addEventListener('focusout', function () {
          setTimeout(function () {
            if (!item.contains(document.activeElement)) {
              close();
            }
          }, 150);
        });

        item.addEventListener('keydown', function (event) {
          if (event.key === 'Escape' || event.key === 'Esc') {
            if (isOpen()) {
              event.preventDefault();
              close();
              link.focus();
            }
          }
        });
      });
    });
  }

  function init() {
    initCssDropdowns();
    initMegaMenus();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
